import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sts-star-rating',
  templateUrl: './star-rating.component.html'
})
export class StarRatingComponent implements OnInit {
  @Input() rating: number = 0;
  @Input() maxRating: number = 5;
  public ratingStars: String[] = [];

  constructor(
  ) { }

  ngOnInit() {
    this.populateStarData();
  }

  private populateStarData() {
    var ratingStars = [];
    var rate = this.rating;
    for (var j = 0; j < this.maxRating; j++) {
      if (rate < (j + 0.5)) {
        ratingStars.push('null');
      } else if (rate >= (j + 0.5) && rate < (j + 1.0)) {
        ratingStars.push('half');
      } else if (rate >= (j + 1.0)) {
        ratingStars.push('full');
      }
    }
    this.ratingStars = ratingStars;
  }
}



// WEBPACK FOOTER //
// ./src/app/lib/star-rating/star-rating.component.ts